<template>
    <div class="btn-group" v-if="value.procedimento.js_complementos && value.procedimento.js_complementos.length">
        <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="disabled">
            {{ value.st_regiao ? value.st_regiao  : 'Região...' }}
        </button>
        <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" 
                href="#" v-for="(regiao, irx) in lista_ordenada" 
                :key="irx"
                @click.prevent="regiao_add(regiao)" :class="regiao_tem(regiao) ? 'active' : ''">
                {{ regiao }}
            </a>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['value', 'disabled'],

    computed: { 
        lista_ordenada: function () { 
            if  ( !this.value )
                return [];

            return _.orderBy(this.value.procedimento.js_complementos);
        },
    },
    
    methods: { 
        regiao_tem (texto) { 
            let items = this.value.st_regiao ? this.value.st_regiao.split(', ') : [];
            return items.find(item => item == texto) ? true : false; 
        },

        regiao_add (texto) { 
            let items = this.value.st_regiao ? this.value.st_regiao.split(', ') : [];

            let index = items.findIndex(item => item == texto);

            if ( index >= 0 ) { 
                items.splice(index, 1);
            } else { 
                items.push(texto);
            }
                
            this.value.st_regiao = items.sort().join(', ');
        },
    }
}
</script>